// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2ik94","info":"UpdateTermsInfo_info__27CVA"};